import { render, staticRenderFns } from "./LastHourCallDuration.vue?vue&type=template&id=71a5465e&scoped=true"
import script from "./LastHourCallDuration.vue?vue&type=script&lang=js"
export * from "./LastHourCallDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5465e",
  null
  
)

export default component.exports